/**
 * Dream4 Webapp — Constantes legadas de API.
 * ------------------------------------------
 * Este arquivo existe APENAS para compatibilidade retroativa com os ~15
 * imports antigos espalhados pelo código. A leitura real das variáveis
 * está em ./env.js (única fonte de verdade).
 *
 * Para código NOVO, importar diretamente:
 *
 *   import env from './Config/env';
 *   axios.get(env.API_URL + '/...')
 *
 * Migração incremental: ao tocar um arquivo legado, trocar
 *   import * as config from '../../Config/api';   →   import env from '../../Config/env';
 *   config.API_URL                                →   env.API_URL
 */

import env from './env';

export const API_URL              = env.API_URL;
export const WS_URL               = env.WS_URL;
export const REACT_APP_SITE_KEY   = env.RECAPTCHA_SITE_KEY;
export const GOOGLE_MAPS_API_KEY  = env.GOOGLE_MAPS_API_KEY;
